<template>
    <div style="min-width: 1800px">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">ETP业务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>交易数据统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="10">
                <el-select v-model="type" placeholder="请选择时间类型" @change="getTransactionNumberTrend"
                           style="float: right;margin-right: 90px;z-index: 9999999">
                    <el-option label="日" value="DAY"></el-option>
                    <el-option label="月" value="MONTH"></el-option>
                </el-select>
                <div id="trade-people" style="width: 100%;height: 350px"></div>
            </el-col>
            <el-col :span="10">
                <el-select v-model="type1" placeholder="请选择时间类型" @change="getTransactionTurnoverTrend"
                           style="float: right;margin-right: 90px;z-index: 9999999">
                    <el-option label="日" value="DAY"></el-option>
                    <el-option label="月" value="MONTH"></el-option>
                </el-select>
                <div id="trade-num" style="width: 100%;height: 350px"></div>
            </el-col>
        </el-row>

        <div>
            <div style="display: inline-block">
                <h1 style="font-size: 18px;display: inline-block">交易数据</h1>
                <span style="font-size: 14px;padding-left: 20px;padding-right: 10px">时间范围</span>
            </div>
            <div style="float: right">
                <h3 style="font-size: 14px;display: inline-block">累计交易人数：{{totalPeopleNumber}}</h3>
            </div>
            <el-date-picker v-model="date" type="datetimerange" value-format="timestamp" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button type="primary" @click="searchData">查 询</el-button>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 10px"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column label="序号">
                    <el-table-column label="合计" type="index" :index="indexMethod" width="100px"></el-table-column>
                </el-table-column>
                <el-table-column label="时间">
                    <el-table-column :label="sumTransactionStatistics.time" prop="time"></el-table-column>
                </el-table-column>
                <el-table-column label="交易额（USDT）">
                    <el-table-column :label="sumTransactionStatistics.turnover+''" prop="turnover"></el-table-column>
                </el-table-column>
                <el-table-column label="净交易额（USDT）">
                    <el-table-column :label="sumTransactionStatistics.pureTurnover+''"
                                     prop="pureTurnover"></el-table-column>
                </el-table-column>
                <el-table-column label="买入额（USDT）">
                    <el-table-column :label="sumTransactionStatistics.buyAmount+''" prop="buyAmount"></el-table-column>
                </el-table-column>
                <el-table-column label="卖出额（USDT）">
                    <el-table-column :label="sumTransactionStatistics.sellAmount+''" prop="sellAmount"></el-table-column>
                </el-table-column>
                <el-table-column label="交易人数">
                    <el-table-column :label="sumTransactionStatistics.transactionNumber+''"
                                     prop="transactionNumber"></el-table-column>
                </el-table-column>
                <el-table-column label="新增交易人数">
                    <el-table-column :label="sumTransactionStatistics.increaseTransactionNumber+''"
                                     prop="increaseTransactionNumber"></el-table-column>
                </el-table-column>
                <el-table-column label="净交易额最大币对">
                    <el-table-column :label="sumTransactionStatistics.pureTransactionMaxCoin+''"
                                     prop="pureTransactionMaxCoin"></el-table-column>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParam.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParam.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import moment from 'moment';

    export default {
        name: 'ManageFee',
        data() {
            return {
                type: "DAY",
                type1: "DAY",
                date: [],
                dataList: [],
                total: 0,
                tradePeopleOption: null,
                tradePeopleChart: null,
                tradeNumOption: null,
                tradeNumChart: null,
                queryParam: {endTime: "", startTime: "",page:1,size:10},
                FORMAT_DAY: 'YYYY-MM-DD',
                FORMAT_MONTH: 'YYYY-MM',
                totalPeopleNumber: 0,
                sumTransactionStatistics: {}
            };
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            },
            momentOne(value) {
                if (!value) return '';
                return moment(value).format(this.type == "DAY" ? this.FORMAT_DAY : this.FORMAT_MONTH);
            },
            momentTwo(value) {
                if (!value) return '';
                return moment(value).format(this.type1 == "DAY" ? this.FORMAT_DAY : this.FORMAT_MONTH);
            },
            searchData() {
                if (this.date) {
                    this.queryParam.startTime = this.date[0];
                    this.queryParam.endTime = this.date[1];
                } else {
                    this.queryParam = {endTime: "", startTime: ""};
                }
                this.getTransactionList();
            },
            getTransactionList() {
                api.getTransactionList(this.queryParam).then(({data}) => {
                    this.dataList = data.transactionStatisticsVOList.records;
                    this.total = data.transactionStatisticsVOList.total;
                    this.totalPeopleNumber = data.totalPeopleNumber;
                    this.sumTransactionStatistics = data.sumTransactionStatisticsVO;
                });
            },
            getTransactionNumberTrend() {
                api.getTransactionNumberTrend({dateType: this.type}).then(({data}) => {
                    this.initTradePeople(data);
                });
            },
            getTransactionTurnoverTrend() {
                api.getTransactionTurnoverTrend({dateType: this.type1}).then(({data}) => {
                    this.initTradeNum(data);
                });
            },
            initTradePeople(data) {
                let _othis = this;
                let tradePeople = document.getElementById('trade-people');
                this.tradePeopleChart = this.$echarts.init(tradePeople);
                this.tradePeopleOption = {
                    title: {
                        text: '交易人数走势'
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function (params) {
                            return "时间：" + _othis.momentOne(params[0].axisValue) + "<br>" + "交易人数：" + params[0].value + " 人";
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'line'
                    }]
                };

                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        this.tradePeopleOption.xAxis.data.push(this.momentOne(data[i].time));
                        this.tradePeopleOption.series[0].data.push(data[i].amount);
                    }
                }

                this.tradePeopleOption && this.tradePeopleChart.setOption(this.tradePeopleOption);
            },
            initTradeNum(data) {
                let _othis = this;
                let tradeNum = document.getElementById('trade-num');
                this.tradeNumChart = this.$echarts.init(tradeNum);
                this.tradeNumOption = {
                    title: {
                        text: '交易额走势'
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function (params) {
                            return "时间：" + _othis.momentTwo(params[0].axisValue) + "<br>" + "交易额：" + params[0].value + " USDT";
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'line'
                    }]
                };

                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        this.tradeNumOption.xAxis.data.push(this.momentTwo(data[i].time));
                        this.tradeNumOption.series[0].data.push(data[i].amount);
                    }
                }

                this.tradeNumOption && this.tradeNumChart.setOption(this.tradeNumOption);
            },
            handleSizeChange(val) {
                this.queryParam.size = val;
                this.getTransactionList();
            },
            handleCurrentChange(val) {
                this.queryParam.page = val;
                this.getTransactionList();
            },
        },
        created() {

        },
        mounted() {
            this.getTransactionList();
            this.getTransactionNumberTrend();
            this.getTransactionTurnoverTrend();
        }
    };
</script>

<style lang="less" scoped></style>

